import { ChangeHistoryEntry } from "../types";
import ChangeHistoryCardMultipleInputsSummary from "./components/MultipleInputsSummary";
import ChangeHistoryCardSingleInputSummary from "./components/SingleInputSummary";
import ChangeHistoryCardVersionAndInputsSummary from "./components/VersionAndInputsSummary";
import ChangeHistoryCardVersionSummary from "./components/VersionSummary";
import ChangeHistoryCardTimeLabel from "./components/TimeLabel";
import ChangeHistoryCardSeparator from "./components/Separator";

type ChangeHistoryCardSummaryProps = {
  entry: ChangeHistoryEntry;
  timeLabel: string;
};

const ChangeHistoryCardSummary = ({ entry, timeLabel }: ChangeHistoryCardSummaryProps) => {
  const { versionChange, inputChanges } = entry;

  if (versionChange && inputChanges.length > 0) {
    return (
      <ChangeHistoryCardVersionAndInputsSummary
        from={versionChange.from}
        to={versionChange.to}
        inputCount={inputChanges.length}
        timeLabel={timeLabel}
      />
    );
  }

  if (versionChange) {
    return (
      <ChangeHistoryCardVersionSummary
        from={versionChange.from}
        to={versionChange.to}
        timeLabel={timeLabel}
      />
    );
  }

  if (inputChanges.length > 1) {
    return (
      <ChangeHistoryCardMultipleInputsSummary
        inputCount={inputChanges.length}
        timeLabel={timeLabel}
      />
    );
  }

  if (inputChanges.length === 1) {
    return <ChangeHistoryCardSingleInputSummary change={inputChanges[0]} timeLabel={timeLabel} />;
  }

  return (
    <>
      <ChangeHistoryCardTimeLabel timeLabel="No changes" />
      <ChangeHistoryCardSeparator />
      <ChangeHistoryCardTimeLabel timeLabel={timeLabel} />
    </>
  );
};

export default ChangeHistoryCardSummary;
